import type { ContractCodes, ContractStatuses } from '@makemydeal/dr-shared-types';
import { ContractCodeStatus } from '@makemydeal/dr-shared-types';

export const ContractingOperation = {
    Start: 'start',
    Cancel: 'cancel',
    Verify: 'verify',
    Status: 'status'
} as const;

export const ContractStatusBadgeInfo = {
    SAVE: {
        label: 'Contract Saved',
        variant: 'info',
        action: 'none'
    },
    CSAV: {
        label: 'Contract Saved',
        variant: 'info',
        action: 'none'
    },
    CFAIL: {
        label: 'Creation Failed',
        variant: 'transparent',
        action: 'showErrors'
    },
    VPEN: {
        label: 'Submitted for Verification',
        variant: 'info',
        action: 'none'
    },
    VEXP: {
        label: 'Verification Expired',
        variant: 'transparent',
        action: 'none'
    },
    VRFA: {
        label: 'Verification Failed',
        variant: 'transparent',
        action: 'showErrors'
    },
    VRWR: {
        label: 'Verified with Warning',
        variant: 'transparent',
        action: 'navigateToDDJ'
    },
    VRFY: {
        label: 'Verified',
        variant: 'transparent',
        action: 'navigateToDDJ'
    },
    PDOC: {
        label: 'Pending Documents',
        variant: 'info',
        action: 'navigateToDDJ'
    },
    SUBS: {
        label: 'Submitted for Signing',
        variant: 'info',
        action: 'navigateToDDJ'
    },
    PSIGN: {
        label: 'Partially Signed',
        variant: 'info',
        action: 'navigateToDDJ'
    },
    SIGN: {
        label: 'Signed',
        variant: 'transparent',
        action: 'navigateToDDJ'
    },
    SUBF: {
        label: 'Submitted for Funding',
        variant: 'info',
        action: 'navigateToDDJ'
    },
    BOOK: {
        label: 'Booked',
        variant: 'transparent',
        action: 'navigateToDDJ'
    },
    FUND: {
        label: 'Funded',
        variant: 'transparent',
        action: 'navigateToDDJ'
    },
    RTRN: {
        label: 'Returned',
        variant: 'transparent',
        action: 'navigateToDDJ'
    },
    CANC: {
        label: 'Cancelled',
        variant: 'transparent',
        action: 'none'
    }
} as const;

/**
 * Creates a reverse mapping from raw event strings to contract status codes.
 * Handles duplicate values by iterating in reverse order, so earlier entries
 * (like SAVE) take precedence over later ones (like CSAV that share the same value).
 * This ensures the mapping is deterministic and validated by TypeScript.
 */
function createReverseStatusCodes(source: Record<ContractCodes, ContractStatuses>): Record<ContractStatuses, ContractCodes> {
    const result: Record<string, ContractCodes> = {};
    const entries = Object.entries(source).reverse();

    for (const [code, status] of entries) {
        result[status] = code as ContractCodes;
    }

    return result as Record<ContractStatuses, ContractCodes>;
}

export const ContractStatusCodes = createReverseStatusCodes(ContractCodeStatus) satisfies Record<ContractStatuses, ContractCodes>;
